<template>
    <div class="wrapper">
        <side-bar>
            <mobile-menu slot="content"></mobile-menu>
            <sidebar-link to="/categories" v-if="role < 2">
                <i class="nc-icon nc-notes"></i>
                <p>Категории</p>
            </sidebar-link>
            <span class="resetspan" @click="resetOffsets">
            <sidebar-link to="/templates">

                    <i class="nc-icon nc-album-2"></i>
                    <p>Шаблоны</p>
            </sidebar-link>
            </span>
            <sidebar-link to="/memories" v-if="role < 2">
                <i class="nc-icon nc-light-3"></i>
                <p>Memories</p>
            </sidebar-link>
            <sidebar-link to="/preview" v-if="role < 2">
                <i class="nc-icon nc-apple"></i>
                <p>Превью</p>
            </sidebar-link>
            <sidebar-link to="/albums" v-if="role < 2">
                <i class="nc-icon nc-single-copy-04"></i>
                <p>Альбомы</p>
            </sidebar-link>
            <sidebar-link to="/tracks" v-if="role < 2">
                <i class="nc-icon nc-note-03"></i>
                <p>Треки</p>
            </sidebar-link>
            <sidebar-link to="/reports" v-if="role < 2">
                <i class="nc-icon nc-chart-bar-32"></i>
                <p>Отчеты</p>
            </sidebar-link>
            <sidebar-link to="/calendar">
                <i class="nc-icon nc-watch-time"></i>
                <p>Календарь</p>
            </sidebar-link>
            <sidebar-link to="/finance" v-if="role < 2">
                <i class="nc-icon nc-money-coins"></i>
                <p>Финансы</p>
            </sidebar-link>
            <sidebar-link to="/push-tasks" v-if="role < 2">
                <i class="nc-icon nc-notification-70"></i>
                <p>Рассылки</p>
            </sidebar-link>
            <sidebar-link to="/logs">
                <i class="nc-icon nc-cctv"></i>
                <p>Логи</p>
            </sidebar-link>
<!--            <sidebar-link to="/icons">-->
<!--                <i class="nc-icon nc-atom"></i>-->
<!--                <p>Icons</p>-->
<!--            </sidebar-link>-->
        </side-bar>
        <div class="main-panel">
            <top-navbar></top-navbar>

            <dashboard-content @click="toggleSidebar">

            </dashboard-content>

            <content-footer></content-footer>
        </div>
    </div>
</template>
<style lang="scss">

    .resetspan {
        display: block;
        width: 100%;
    }

</style>
<script>
    import TopNavbar from './TopNavbar.vue'
    import ContentFooter from './ContentFooter.vue'
    import DashboardContent from './Content.vue'
    import MobileMenu from './MobileMenu.vue'

    export default {
        components: {
            TopNavbar,
            ContentFooter,
            DashboardContent,
            MobileMenu
        },
        data() {
            return {
                role: parseInt(localStorage.getItem('role')) || 0,
            }
        },
        methods: {
            toggleSidebar () {
                if (this.$sidebar.showSidebar) {
                    this.$sidebar.displaySidebar(false)
                }
            },
            resetOffsets: function() {
                localStorage.setItem('w_active_offset', 0);
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/components/Dashboard/Layout/DashboardLayout.vue